import * as entities from '../entities'

import { userSchema } from './schemas'
import featureToggles from 'shared/featureToggles'
import { pendingSelector } from 'api/selectors'

export const userIdSelector = state => state.user
const userEntitySelector = entities.selectors.createDenormalizedSelector(userIdSelector, userSchema)
export const tokenSelector = createSelector(userEntitySelector, user => (user && user.token ? user.token : null))
export const userSelector = createSelector(userEntitySelector, user => (user && user.id ? user : null))
export const userAccountIdSelector = createSelector(userSelector, user => (user ? user.accountId : null))

export const businessAccountSelector = createSelector(
    userSelector,
    user => user && user?.extended?.fieldMap?.businessAccount?.value
)

export const userDetailsSelector = createSelector(userSelector, user => (user ? user.details : {}))

export const deliveryAddressSelector = createSelector(
    userDetailsSelector,
    userDetails => userDetails.deliveryAddress || {}
)
export const billingAddressSelector = createSelector(
    userDetailsSelector,
    userDetails => userDetails.billingAddress || {}
)
export const documentSelector = createSelector(userDetailsSelector, userDetails => userDetails.document || {})
export const nifSelector = createSelector(userDetailsSelector, userDetails => userDetails.custom1 || null)

export const isNifRequiredAndMissingSelector = createSelector(nifSelector, nif => featureToggles.nifRequired && !nif)

export const accountKeySelector = createSelector(userSelector, user => (user ? user.accountKey : null))

const normalizedWaitingListSelector = state => state.latestConfirmedReservation
export const hasConfirmedWaitingListSelector = createSelector(
    normalizedWaitingListSelector,
    waitingListRecord => !!waitingListRecord
)

export const userPendingSelector = createSelector(pendingSelector, pending => pending.getCurrentUser || false)

export const createUserCreditCardInfoSelector = cardIdSelector =>
    createSelector(userSelector, cardIdSelector, (user, cardId) => {
        const creditCard = user && user?.creditCards.find(user => user?.id === cardId)

        if (!creditCard) {
            return null
        }

        const { cardType, lastFour } = creditCard

        return `${cardType} **** ${lastFour}`
    })
